import { combineReducers } from 'redux';

const defaultUnassignedFilter = '';
const unassignedFilter = (state = defaultUnassignedFilter, action) => {
  switch (action.type) {
    case 'UNASSIGNED_FILTER_CHANGE':
      return action.searchString;
    case 'ASSIGN_OBI_TO_BOX':
    case 'UNASSIGNED_OBI_HIDE':
      return defaultUnassignedFilter;
    default:
      return state;
  }
};

const defaultUnassignedLoading = false;
const unassignedLoading = (state = defaultUnassignedLoading, action) => {
  switch (action.type) {
    case 'POPULATE_EPI':
      return true;
    case 'POPULATE_EPI_SUCCESS':
    case 'POPULATE_EPI_ERROR':
      return false;
    default:
      return state;
  }
};

const defaultModifyStatus = false;
const modifyEditStatus = (state = defaultModifyStatus, action) => {
  switch (action.type) {
    case 'MODIFY_EDIT_STATUS_SUCCESS':
      return action.status;
    default:
      return state;
  }
};

const defaultUnassignedEPISListLoading = false;
const unassignedEPIsListLoading = (state = defaultUnassignedEPISListLoading, action) => {
  switch (action.type) {
    case 'UNASSIGNED_OBIS':
      return true;
    case 'UNASSIGNED_OBIS_SUCCESS':
    case 'UNASSIGNED_OBIS_ERROR':
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  unassignedFilter,
  unassignedLoading,
  unassignedEPIsListLoading,
  modifyEditStatus,
});
